import { cn } from '@/lib/utils';
import { ISignalDailyToken } from '@/request/signal/signal.response.interface';
import { useAppStore } from '@/store';
import TokenAvatar from '@/widget/TokenAvatar';
import BigNumber from 'bignumber.js';
import { Link } from 'react-router-dom';

interface IProps {
  token: ISignalDailyToken;
}

export default (props: IProps) => {
  const { token } = props;
  const {
    fwClass,
    chainInfo: { path },
  } = useAppStore();

  // const timestamp = token.timestamp * 1000;
  // const date = formatDate(timestamp).replace(/^\d{4}\//, '');
  const maxPriceChg = BigNumber(token.highestPrice).minus(token.firstAlertPrice).div(token.firstAlertPrice).toString();
  const multiple = BigNumber(maxPriceChg).lt(1) ? `<1` : maxPriceChg.toString().split('.')[0];

  return (
    <Link to={`/${path}/trade/${token.address}`} className="flex h-full items-center border-b-[1px] border-borderColor">
      <div className="w-[120px] flex items-center gap-x-[8px]">
        <TokenAvatar className="size-[30px]" address={token?.address} logo={token?.logo} />
        <span className={cn('w-[80px] overflow-hidden text-ellipsis', fwClass)}>{token?.symbol}</span>
      </div>
      <div className="flex-1 text-center">
        <div className="inline-flex items-center text-themeColor">
          <span className={cn('text-[16px]', fwClass)}>{token.pushTimes}</span>
          <img src="/icon/notice.svg" className="mb-[20px] flex-shrink-0 size-[16px]" />
        </div>
      </div>
      <div className="w-[96px] flex justify-center text-themeColor">
        <div className="relative bg-[url(/icon/chg.svg)] w-[44px] h-[32px] bg-cover bg-no-repeat text-center pt-[10px]">
          <span className={cn('text-[16px]', fwClass)}>{multiple}x</span>
        </div>
      </div>
    </Link>
  );
};
